export const PERSONAL_DETAILS_STEP = 'personalDetails';
export const APPLICATION_STEP = 'application';
export const SUBMITTING_STEP = 'submitting-acceptance';

const COMPANY_REJECTED_STEP = 'company-rejected';
export const DENIED_STEP = 'denied';
export const CLARITY_UNFREEZE_STEP = 'clarity-unfreeze';
export const SUCCESS_STEP = 'success';
export const IDV_FAILED_STEP = 'idv-failed';
export const SOLO_EXPLAINER_STEP = 'solo-explainer';

export const MARKETPLACE_CARD_APPLICATION_STEPS = [
    PERSONAL_DETAILS_STEP,
    APPLICATION_STEP,
    SUBMITTING_STEP,
    SUCCESS_STEP,
    SUBMITTING_STEP,
    CLARITY_UNFREEZE_STEP,
    COMPANY_REJECTED_STEP,
    DENIED_STEP,
    IDV_FAILED_STEP,
    SOLO_EXPLAINER_STEP,
];
